module.exports = __webpack_public_path__ + "media/images/contact_page-2af70ae3554e88585a17e120ee75d40f.svg";